import { csHttp } from "./http";

export const csInitPayment = (payload) =>
  csHttp.post("/api/payments/epoint/init", payload).then((r) => r.data);

export const csMyPayments = (phone) =>
  csHttp.get("/api/me/payments", { params: { phone } }).then((r) => r.data);
